var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-contact" },
    [
      _c("h3", { staticClass: "checkout-contact__title" }, [
        _vm._v("Контактные данные")
      ]),
      _c("checkout-auth", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.LOGGED_IN,
            expression: "!LOGGED_IN"
          }
        ]
      }),
      _c("div", { staticClass: "checkout-contact-form" }, [
        _c(
          "div",
          [
            _c("ui-input", {
              ref: "name",
              attrs: {
                label: "Имя *",
                placeholder: "Имя",
                validate: ["name"],
                clearable: ""
              },
              on: { blur: _vm.saveForm },
              model: {
                value: _vm.name,
                callback: function($$v) {
                  _vm.name = $$v
                },
                expression: "name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("ui-input", {
              ref: "phone",
              attrs: {
                label: "Телефон *",
                placeholder: "Телефон",
                mask: "phone",
                type: "tel",
                validate: "phone",
                error: _vm.phoneError,
                clearable: ""
              },
              on: {
                "on-valid": _vm.handlePhone,
                "is-valid": _vm.togglePhoneValid
              },
              scopedSlots: _vm._u(
                [
                  _vm.isPhoneExists
                    ? {
                        key: "error",
                        fn: function() {
                          return [
                            _c("exists-error", {
                              attrs: { type: "tel" },
                              on: { login: _vm.onPhoneLogin }
                            })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              ),
              model: {
                value: _vm.phone,
                callback: function($$v) {
                  _vm.phone = $$v
                },
                expression: "phone"
              }
            }),
            _c(
              "vue-client-only",
              [
                _vm.phoneValid &&
                _vm.confirmRequired &&
                !_vm.phoneError &&
                !_vm.codeSent &&
                !_vm.retryTimeoutSeconds
                  ? _c("div", { staticClass: "checkout-contact__code-hint" }, [
                      _vm._v(
                        "\n          На указанный номер будет отправлен код подтверждения\n        "
                      )
                    ])
                  : _vm._e(),
                _vm.phoneValid &&
                _vm.confirmRequired &&
                !_vm.phoneError &&
                _vm.codeSent &&
                _vm.retryTimeoutSeconds > 0
                  ? _c("div", { staticClass: "checkout-contact__code-hint" }, [
                      _vm._v(
                        "\n          На указанный номер отправлен код подтверждения\n        "
                      )
                    ])
                  : _vm._e(),
                _vm.confirmRequired
                  ? [
                      _vm.phoneValid && !_vm.codeSent && !_vm.isPhoneExists
                        ? [
                            _c("div", [
                              _vm.retryTimeoutSeconds > 0
                                ? _c("p", { staticClass: "countdown" }, [
                                    _vm._v(
                                      "\n                Повторная отправка возможна через " +
                                        _vm._s(_vm.retryTimeout) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            !_vm.retryTimeoutSeconds
                              ? _c("ui-button", {
                                  staticClass: "checkout-contact__phone-submit",
                                  attrs: {
                                    wide: "",
                                    text: "Получить код",
                                    disabled:
                                      _vm.retryTimeoutSeconds > 0 &&
                                      _vm.confirmedPhones.length > 0,
                                    loading: _vm.codeProgress
                                  },
                                  on: { click: _vm.requestCode }
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.phoneValid && _vm.codeSent
                        ? [
                            _c("ui-input", {
                              ref: "code",
                              attrs: {
                                error: _vm.codeError,
                                name: "code",
                                mask: "code",
                                label: "Код *",
                                validate: "code",
                                clearable: "",
                                numbers: "",
                                type: "tel",
                                placeholder: "Введите код из SMS"
                              },
                              on: {
                                "is-valid": _vm.onCodeValid,
                                input: function($event) {
                                  _vm.codeError = ""
                                }
                              },
                              model: {
                                value: _vm.code,
                                callback: function($$v) {
                                  _vm.code = $$v
                                },
                                expression: "code"
                              }
                            }),
                            !_vm.retryTimeoutSeconds && _vm.codeSent
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "countdown resend",
                                    on: { click: _vm.requestCode }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Отправить код повторно\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c("div", [
                              _vm.retryTimeoutSeconds > 0
                                ? _c("p", { staticClass: "countdown" }, [
                                    _vm._v(
                                      "\n                Повторная отправка возможна через " +
                                        _vm._s(_vm.retryTimeout) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm.codeSent
                              ? _c("ui-button", {
                                  staticClass: "checkout-contact__code-submit",
                                  attrs: {
                                    wide: "",
                                    text: "Подтвердить",
                                    disabled: !_vm.isCodeValid,
                                    loading: _vm.codeSubmitProgres
                                  },
                                  on: { click: _vm.verifyCode }
                                })
                              : _vm._e()
                          ]
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c("ui-input", {
              ref: "email",
              attrs: {
                label: "Email *",
                placeholder: "Email",
                validate: "email",
                error: _vm.emailError,
                clearable: "",
                disabled: !!_vm.ACCOUNT.email
              },
              on: {
                blur: _vm.saveForm,
                "on-valid": _vm.handleEmail,
                "is-valid": _vm.onEmailValidChange
              },
              scopedSlots: _vm._u(
                [
                  _vm.isEmailExists
                    ? {
                        key: "error",
                        fn: function() {
                          return [
                            _c("exists-error", {
                              attrs: { type: "email" },
                              on: { login: _vm.onEmailLogin }
                            })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              ),
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _vm.showSubscribe
              ? _c("ui-checkbox", {
                  staticClass: "checkout-contact__subscribe",
                  attrs: { label: "Подписаться на акции и скидки" },
                  model: {
                    value: _vm.subscribe,
                    callback: function($$v) {
                      _vm.subscribe = $$v
                    },
                    expression: "subscribe"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }